import { Wallet } from 'dragonmouse-shared/economy';
import { updateWallet } from '../../redux/db/actions';
import store from '../../redux/store';
import { VITE_FORGE_URL } from '../../constants';
import { WalletRow } from '../types';
import { parsePostgresDate } from '../util';
import { Stream } from './Stream';

export class WalletStream extends Stream<WalletRow> {
	constructor(userId: string) {
		const url = VITE_FORGE_URL + '/electric/wallet';
		const params = { userId };

		const onError = (error: Error) => {
			console.error('Wallet stream error:', error);
			store.dispatch(updateWallet(null));
		};

		super(url, params, onError, undefined); // No loading resource key for now
	}

	onShapeData(rows: WalletRow[]) {
		if (rows.length > 0) {
			const walletRow = rows[0];
			const wallet: Wallet = {
				userId: walletRow.user_id,
				silver: walletRow.silver,
				gold: walletRow.gold,
				silverRefill: walletRow.silver_refill ? parsePostgresDate(walletRow.silver_refill) : null,
				goldRefill: walletRow.gold_refill ? parsePostgresDate(walletRow.gold_refill) : null,
				updatedAt: parsePostgresDate(walletRow.updated_at),
			};
			store.dispatch(updateWallet(wallet));
		} else {
			store.dispatch(updateWallet(null));
		}
	}

	onStreamMessages(messages: Array<unknown>) {
		// For now, we don't handle optimistic updates for wallet
		// In the future, we could add this if needed
	}
}
